/** Handlers tear down Supabase realtime channels when connectivity is unreachable. */

const teardownHandlers = new Set();

export function registerRealtimeTeardownHandler(handler) {
  teardownHandlers.add(handler);
  return () => {
    teardownHandlers.delete(handler);
  };
}

export function runRealtimeTeardownHandlers() {
  teardownHandlers.forEach((handler) => {
    try {
      handler();
    } catch (err) {
      console.error('[realtime] teardown handler failed:', err);
    }
  });
}
